import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general'),
      meta: {
        superAdminOnly: true,
        permissions: ['administrator'],
        // ACESSO-01 (L8b): editar a conta (`accounts#update`), travado: o super admin.
        escopos: ['account:manage'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'general_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
            escopos: ['account:manage'],
          },
        },
      ],
    },
  ],
};
